import { render, staticRenderFns } from "./IndexFooter.vue?vue&type=template&id=b4fd56e6&scoped=true&"
import script from "./IndexFooter.vue?vue&type=script&lang=ts&"
export * from "./IndexFooter.vue?vue&type=script&lang=ts&"
import style0 from "./IndexFooter.vue?vue&type=style&index=0&id=b4fd56e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fd56e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4fd56e6')) {
      api.createRecord('b4fd56e6', component.options)
    } else {
      api.reload('b4fd56e6', component.options)
    }
    module.hot.accept("./IndexFooter.vue?vue&type=template&id=b4fd56e6&scoped=true&", function () {
      api.rerender('b4fd56e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/IndexFooter.vue"
export default component.exports